import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  UserFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Header, BuysellDetails } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const EditBuysell = withRouter(props => {

  const classes = useStyles();
  const [productobj , setProductobj] = useState({});
  const [userid, setUserid] = useState('');
  const [posttype, setPosttype] = useState({});
  const [open, setOpen] = React.useState(false);

  const [masters, setMasters] = useState({
    commodity :[]
  });

  const { sendNetworkRequest } = React.useContext(NetworkContext);


  async function fetchmasters()
  {
    let commodities = await sendNetworkRequest('/fetchbuycommodity', {}, {},false)
    let quantities = await sendNetworkRequest('/fetchmasterquantity', {}, {},false)

    setMasters({
      ...masters,
      commodity : commodities,
      quantity : quantities
    })
   
  }
  const handleClose = () => {
    setOpen(false);
  };
  async function updateproductinfo(productdetails)
  {
    setOpen(!open);
    let bodycontent = {
      ...productdetails,
     ...posttype
    }
    let prodinfo = await sendNetworkRequest('/managebuysell', {}, {postinfo : bodycontent},false)
    setOpen(false);
  }
  async function fetchproductinfo(prodid)
  {
    let prodinfo = await sendNetworkRequest('/fetchpostinfo', {}, {postid : prodid},false)
    // <TableCell>{order.post_commodities ? order.post_commodities.map((element) => 
    //   <>
    //   {` ${element.buysellcommodity.name}`}
    //   </>
    // ) :''}</TableCell>

    let commodities = [];
    prodinfo.post_commodities.forEach(element => {
        commodities.push({
          label : element.buysellcommodity.name,
          value : element.buysellcommodity.id
        })
    });
    setProductobj({
      ...prodinfo,
      commodity:commodities,
     ismobile :  prodinfo.is_contact_emobile,
    isemail : prodinfo.is_contact_email
    })
  }
  useEffect(() => {
     const post_type = props.location.pathname.split('/')[2];
     const post_id = props.location.pathname.split('/')[3];

     // var viewtype = props.location.pathname.split('/')[3];
    // setViewtype(viewtype)
    // setUserid(user_id)
    if(post_type)
    {
      setPosttype({
        ...posttype,
        type : post_type
      })
    }
    if(post_id)
    {
      setPosttype({
        ...posttype,
        postid : post_id
      })
      fetchproductinfo(post_id);
    }
    
    fetchmasters()
  }, []);

  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
     <BuysellDetails usercontent={productobj} masters={masters} viewtype={posttype} onUpdate={updateproductinfo}/>  
     <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Page>
  );
});

export default EditBuysell;
